import {HttpServices} from "../Helpers";

export const GetSetupsHierarchy = async ({
  uuid,
  use_for = "dropdown",
  other_than,
  with_than,
  limit,
  page,
  query,
  status,
  check_rules,
} = {}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (check_rules) queryList.push(`check_rules=${check_rules}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/setup/${
      process.env.REACT_APP_VERSION_API
    }/organizational/hierarchy?${queryList.join("&")}`,
    {
      params: {with_than, other_than, query, page, limit, status},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const UpdateSetupsHierarchy = async (body) => {
  const result = await HttpServices.put(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/setup/${process.env.REACT_APP_VERSION_API}/organizational/hierarchy`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
